import React, { useState, useRef, useEffect } from 'react';

const PRESETS = [0, 25, 50, 75, 100];

// Jauge d'avancement : on la déplace à la main, la valeur ne part au serveur
// qu'au relâchement (un seul enregistrement par geste, pas un par pixel).
export default function ProgressGauge({ value = 0, onCommit, saving = false }) {
  const [draft, setDraft] = useState(value);
  const dragging = useRef(false);
  const latest = useRef({ draft: value, value, onCommit });

  useEffect(() => { latest.current = { draft, value, onCommit }; });

  // Tant qu'on ne glisse pas, la valeur du serveur reprend la main.
  useEffect(() => {
    if (!dragging.current) setDraft(value);
  }, [value]);

  // Le doigt ou la souris peut se relever hors du curseur : on écoute la fenêtre.
  useEffect(() => {
    const end = () => {
      if (!dragging.current) return;
      dragging.current = false;
      const { draft: d, value: v, onCommit: commit } = latest.current;
      if (d !== v) commit(d);
    };
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    return () => {
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
    };
  }, []);

  const pick = (next) => {
    dragging.current = false;
    setDraft(next);
    if (next !== value) onCommit(next);
  };

  return (
    <div className="gauge">
      <div className="gauge-head">
        <span className="gauge-label">Avancement du chantier</span>
        <span className="gauge-value">{draft}<span className="gauge-unit">%</span></span>
      </div>

      <input
        className="gauge-range"
        type="range"
        min="0"
        max="100"
        step="1"
        value={draft}
        disabled={saving}
        aria-label="Avancement du chantier, en pourcentage"
        style={{ background: `linear-gradient(90deg, var(--primary) ${draft}%, var(--border) ${draft}%)` }}
        onChange={(e) => { dragging.current = true; setDraft(Number(e.target.value)); }}
        onKeyUp={() => { if (draft !== value) { dragging.current = false; onCommit(draft); } }}
      />

      <div className="gauge-presets">
        {PRESETS.map(p => (
          <button
            key={p}
            type="button"
            className={`gauge-preset ${draft === p ? 'active' : ''}`}
            disabled={saving}
            onClick={() => pick(p)}
          >
            {p}%
          </button>
        ))}
        <span className="gauge-hint">{saving ? 'Enregistrement…' : 'Glissez pour ajuster'}</span>
      </div>
    </div>
  );
}
